import { Geometry } from "geojson";
import { ScreenCreateNodesRequest, ScreenSearchPolygonResponse } from "../models/Screen";
import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const searchPolygon = async (rings: Geometry) =>
  await jwtAuthAxios().post<ScreenSearchPolygonResponse>(
    `/screen/search-polygon`,
    rings
  );

export const createScreenNodes = async (body: ScreenCreateNodesRequest) =>
  await jwtAuthAxios().post(`/screen/create-nodes`, body);
